import { Injectable } from '@angular/core';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ActivatedRoute, Event as NavigationEvent, NavigationEnd, Router } from '@angular/router';
import { UtilService } from '@service/util/util.service';
import { DATE_TIME, IS_EMPTY, IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

import { environment } from '@environment/environment';
import { API_PATH, CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { API_ERROR_STRING, UNABLE_TO_PROCESS_REQUEST } from '@domain/constants/error';
import { HttpCancelService } from '../http-cancel/http-cancel.service';
import { catchError, filter, map, takeUntil } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
	private LOGIN_SETUP_URL = 'loginSetup';

	constructor(
		private router: Router,
		private utilService: UtilService,
		private _activeRoute: ActivatedRoute,
		private httpCancelService: HttpCancelService
	) {
		router.events
			.pipe(
				filter((event: NavigationEvent) => {
					return event instanceof NavigationEnd;
				})
			)
			.subscribe((event: NavigationEnd) => {
				let previousRoute = localStorage.getItem('previousRoute'),
					currentRoute = event.url.split('?')[0];
				if (
					!this.utilService.isNullOrUndefined(previousRoute) &&
					!this.utilService.isNullOrUndefined(currentRoute)
				) {
					previousRoute = previousRoute.split('?')[0];
					if (previousRoute != currentRoute) {
						this.httpCancelService.cancelPendingRequests();
					}
				}
			});
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next
			.handle(req)
			.pipe(takeUntil(this.httpCancelService.onCancelPendingRequests(req)))
			.pipe(
				map((event: HttpEvent<any>) => {
					if (req?.url?.indexOf(this.LOGIN_SETUP_URL) > -1) {
						localStorage.setItem(CARGOCHIEF_KEYS.LOGIN_SETUP_LAST_UPDATE, DATE_TIME(new Date()));
					}
					return event;
				})
			)
			.pipe(
				catchError((err: any) => {
					if (err instanceof HttpErrorResponse) {
						if (err.status === 401) {
							localStorage.clear();
							let errorMessage = err['error']['message'];
							if (IS_EMPTY(errorMessage)) {
								errorMessage = err.error;
							}
							localStorage.setItem('sessionExpired', 'true');
							if (IS_NOT_EMPTY(errorMessage) && errorMessage.indexOf('DOCTYPE') == -1) {
								localStorage.setItem('sessionErrorMsg', errorMessage);
							}
							this.router.navigate(['login']);
						} else if (
							err.status >= 400 &&
							err.status < 500 &&
							!(err.url.indexOf(API_PATH.REGISTER_DEVICE_API) > 0) &&
							!(err.url.indexOf(API_PATH.TOP_SEARCHES) > 0) &&
							!(
								window.location.href.indexOf(API_PATH.ASCEND.toLowerCase()) > 0 &&
								err.url.indexOf(API_PATH.CARRIER_HUB_API) > 0
							)
						) {
							this.utilService.showSnackbar(
								API_ERROR_STRING.ERR_400_500,
								SNACKBAR.ERROR,
								SNACKBAR.ACTION
							);
						} else if (err.status === 500) {
							this.utilService.showSnackbar(
								API_ERROR_STRING.ERR_500,
								SNACKBAR.ERROR,
								SNACKBAR.ACTION
							);
						} else if (err.status === 502) {
							this.utilService.showSnackbar(
								API_ERROR_STRING.ERR_502,
								SNACKBAR.WARNING,
								SNACKBAR.ACTION
							);
						} else if (err.status === 503) {
							this.router.navigate(['maintenance']);
						}
						let customError: any = JSON.parse(JSON.stringify(err));
						let key = this.isHTMlError(customError);
						if (IS_NOT_NULL_OR_UNDEFINED(key)) {
							customError[key] = UNABLE_TO_PROCESS_REQUEST;
						}
						return throwError(customError);
					}
				})
			);
	}

	private isHTMlError(customError: any) {
		let error_keys = ['data', 'error', 'error'['text'], 'error'['message']];
		for (var key in error_keys) {
			if (
				IS_NOT_EMPTY(customError[error_keys[key]]) &&
				customError[error_keys[key]].indexOf('DOCTYPE') !== -1
			) {
				return error_keys[key];
			}
		}
		return null;
	}
}
